var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"contents",class:{
        bank: _vm.isBank,
        sign: _vm.isSign,
      }},[_vm._t("default")],2),_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('click_overlay')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }